import { useState } from "react";
import { Form } from "react-bootstrap";
import { faPlus, faComment } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CommentsForm from "../Form/CommentsForm";
import ErrorPopup from "../../../../../layout/ErrorPopup";
import CrmConfig from "@serie3/freelancesplaceapi/Config/Crm/CrmConfig";
import CommentView from "../../../../../layout/CommentView";

const Comments = ({ commentsData, companyId, setCommentsData, personId }) => {
  const [showEdit, setShowEdit] = useState(false);
  const [editComment, setEditComment] = useState(null);
  const [showError, setShowError] = useState(false);

  return (
    <>
      <ErrorPopup setShowError={setShowError} showError={showError}>
        Sorry! Something went wrong.{" "}
        <strong>If you think this is a bug, please contact support.</strong>
      </ErrorPopup>

      <Form>
        <CommentsForm
          showEdit={showEdit}
          setShowEdit={setShowEdit}
          editComments={editComment}
          companyId={companyId}
          personId={personId}
          dataList={commentsData}
          setCommentsData={setCommentsData}
          showErrorFunction={() => setShowError(true)}
        />
      </Form>

      <div style={{ padding: "0 4px" }}>
        {commentsData && commentsData.length > 0 ? (
          commentsData.map((comment, index) => (
            <CommentView
              key={index}
              index={index}
              keyValueObject={comment}
              setShowEdit={setShowEdit}
              setEditFunction={setEditComment}
              setKeyValueData={setCommentsData}
              keyValueDataList={commentsData}
              showErrorFunction={() => setShowError(true)}
              deleteUrl={CrmConfig.comments.endpoints.delete}
            />
          ))
        ) : (
          <div style={{
            display: "flex", flexDirection: "column", alignItems: "center",
            padding: "40px 20px", color: "#bdbdbd",
          }}>
            <FontAwesomeIcon icon={faComment} style={{ fontSize: "2rem", marginBottom: "10px" }} />
            <span style={{ fontSize: "0.9rem" }}>No comments yet</span>
          </div>
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px 4px 4px" }}>
        <button
          type="button"
          onClick={() => { setEditComment(null); setShowEdit(true); }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            padding: "8px 16px", background: "#e8f5e9", color: "#2e7d32",
            border: "none", borderRadius: "10px", fontWeight: 700,
            fontSize: "0.85rem", cursor: "pointer", transition: "background 0.15s",
          }}
          onMouseOver={e => e.currentTarget.style.background = "#c8e6c9"}
          onMouseOut={e => e.currentTarget.style.background = "#e8f5e9"}
        >
          <FontAwesomeIcon icon={faPlus} style={{ fontSize: "0.75rem" }} />
          Add Comment
        </button>
      </div>
    </>
  );
};

export default Comments;
